module.exports = __webpack_public_path__ + "img/wz3.a2e3afcc.png";